<template>
  <div class="card">
    <a @click="$router.push(`/blog/${data.id}`)"><img
      v-bind:src="data.image"
      srcset="
        ../../assets/BlogList/1/Blog-Image@2x.png 2x,
        ../../assets/BlogList/1/Blog-Image@3x.png 3x
      "
      class="Blog-Image"
    /></a>
    <a @click="$router.push(`/blog/${data.id}`)"><p class="title-card">
      {{data.title}}
    </p></a>
    <p class="Writer">{{data.author }} <span class="Date">{{data.date}}</span></p>

    <p class="Desc">
      {{data.desc}}
    </p>
    <p class="Category">
        {{data.category}} <img class="Ellipse " /> {{data.subCategory}}
    </p>
  </div>
</template>
<script>
export default {
    props:["data"],
    
};
</script>
<style scoped>
.title-card {
  width: 333px;
  height: 44px;
  flex-grow: 0;
  margin: 16px 0;
  font-family: Sora;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.Date {
  /* width: 85px; */
  /* height: 22px; */
  flex-grow: 0;
  /* margin: 16px 0 16px 10px; */
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: right;
  float:right;
  color: #b5b5b5;
}
.Writer {
  width: 333px;
  /* height: 22px; */
  flex-grow: 0;
  margin: 16px 0 16px 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.Category {
  /* width: 238px; */
  height: 22px;
  flex-grow: 0;
  margin: 16px 10px 0 0;
}
.Ellipse {
  width: 4px;
  height: 4px;
  flex-grow: 0;
  margin: auto 8px 4px 0;
  background-color: #252525;
}

.card {
  position: relative;
  margin: 0 0 50px 25px;
  /* margin-right: 25px; */
  /* width: 333px; */
}

.Desc {
  width: 333px;
  height: 60px;
  flex-grow: 0;
  margin: 16px 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
</style>
